import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { PPAContract } from "../../PPAContractPage.types";

export function getNextTerminationDeadlineColumn(): MRT_ColumnDef<PPAContract> {
  return {
    accessorKey: "next_termination_deadline",
    accessorFn: (row) =>
      backendDateOrDateTimeToLuxonDateTimeOrNull(
        row.next_termination_deadline
      )?.toJSDate(),
    header: "Kündbar bis",
    size: 150,
    Cell: ({ row }) => {
      if (row.original.next_termination_deadline === null) {
        return null;
      }

      return backendDateOrDateTimeToLuxonDateTime(
        row.original.next_termination_deadline
      ).toFormat(DATE_DISPLAY_FORMAT);
    },
    filterVariant: "date-range"
  };
}
